<template lang="pug">
article
  template(v-if="!data")
    .brand-card
      a.image
        .contain.clp
      .caption
        a.name.clp.w-6 &nbsp;
        .address.clp.w-9 &nbsp;

  template(v-else)
    nuxt-link.brand-card(
      :to="link"
      :title="data.name"
      v-click="() => $amplitude.trackBrand(trackProps)"
    )
      .image
        .contain(v-image="data.logo_url && data.logo_url.medium_url")
      .caption
        .name.pf-ellipsis(v-text="data.name")
        .address(:title="data | brandAddress") {{ data | brandAddress }}
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
    trackProps: {
      type: [Object, String],
      default: ''
    }
  },

  computed: {
    link () {
      return this.$links
        .brand({
          id: this.data.id,
          name: this.data.name
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-card {
  background: white;
  box-sizing: content-box;
  border: 1.5px solid transparent;
  border-radius: $--radius;
  align-items: center;
  display: flex;
  &:hover {
    z-index: 1;
    border: 1.5px solid $--color-primary;
  }
  .image {
    display: block;
    padding: 10px;
    flex: 0 64px;
    position: relative;
    margin-right: 12px;
    box-sizing: content-box;
    .contain {
      width: 100%;
      height: 0;
      padding-top: 100%;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      border-radius: calc($--radius / 2);
    }
  }
  .caption {
    flex: 1;
    min-width: 0;
    padding-right: 10px;
    .name {
      display: block;
      font-size: 14px;
      line-height: 1.3em;
      font-weight: $--font-weight-bold;
      color: $--color-text-regular;
    }
    .address {
      display: block;
      color: $--color-text-secondary;
      font-size: 13px;
      line-height: 1em;
      margin-top: .75em;
    }
  }
}
</style>
